import { Button, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import { CicloOrcamentarioProjetoDadosGerais, CicloOrcamentarioRelatorio, getCicloOrcamentarioProjetoDadosGerais, postGetAllRelatorioCicloOrcamentario, Filtros, relatorioExportExcel } from '@app/api/relatorioCicloorcamentario';
import RelatorioCicloOrcamentarioProjetoDadosGerais from '@app/views/RelatorioCicloOrcamentarioProjeto/dadosGerias';
import AbaPacote from '@app/views/RelatorioCicloOrcamentarioProjeto/AbaPacote';
import Grafico from '@app/views/RelatorioCicloOrcamentarioProjeto/Graficos';
import { GraficoEconomicoCicloAnualProjeto, ReportCicloOrcamentario } from '@app/api/relatorios';
import RelatorioCicloOrcamentarioTabela from '@app/views/RelatorioCicloOrcamentario/relatorioCicloOrcamentarioTabela';
import { postExportarRelatorio } from '@app/api/relatorioProjetoPacote';

const { Panel } = Collapse;
interface ResultCicloAnoProps {
    projetoId: string;
}


const DadosGerias = (props: ResultCicloAnoProps) => {
    const { projetoId } = props;
    const filtro = {} as Filtros;
    const [cicloOrcamentarioProjetoDadosGerais, setCicloOrcamentarioProjetoDadosGerais] = useState<CicloOrcamentarioProjetoDadosGerais>();

    useMemo(() => {
        if (projetoId) {
            getCicloOrcamentarioProjetoDadosGerais(projetoId).then((data) => {
                setCicloOrcamentarioProjetoDadosGerais(data);
            });
        }
    }, [projetoId]);

    return (
        <>
            <RelatorioCicloOrcamentarioProjetoDadosGerais
                cicloOrcamentarioProjetoDadosGerais={cicloOrcamentarioProjetoDadosGerais ? cicloOrcamentarioProjetoDadosGerais : {} as CicloOrcamentarioProjetoDadosGerais}
            />
        </>
    );

}

export default DadosGerias;

